<template>
  <div class="p-4">
    <div>
      <logos />
    </div>
    <div>
      <div class="mt-4">
        <h2 class="font-bold text-4xl">
          Pending Surveys
        </h2>
      </div>

      <table
        v-if="hasPendingSurveys"
        class="mt-4 border border-gray-800 w-full"
      >
        <tr>
          <th class="py-2 px-4 font-bold">
            Survey ID
          </th>
          <th class="py-2 px-4 font-bold">
            Date
          </th>
          <th class="py-2 px-4 font-bold">
            Time
          </th>
        </tr>
        <tr
          v-for="(survey, surveyIndex) in pendingSurveys"
          :key="survey.time"
          :class="{ 'bg-gray-800': surveyIndex % 2 === 0 }"
        >
          <td
            class="py-2 px-4 border-r"
            :class="{ 'border-gray-900': surveyIndex % 2 === 0, 'border-gray-800': surveyIndex % 2 !== 0 } "
          >
            {{ survey.hash }}
          </td>
          <td
            class="py-2 px-4 border-r"
            :class="{ 'border-gray-900': surveyIndex % 2 === 0, 'border-gray-800': surveyIndex % 2 !== 0 }"
          >
            {{ survey.time | dateFormat }}
          </td>
          <td
            class="py-2 px-4"
          >
            {{ survey.time | timeFormat }}
          </td>
        </tr>
      </table>

      <div
        v-if="!hasPendingSurveys"
        class="mt-4"
      >
        No Pending Surveys
      </div>

      <router-link
        :to="{ name: 'home' }"
        class="mt-10 flex justify-between items-center w-80 text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
      >
        <span>Back</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22 22"
          class="w-8 h-8"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            d="M1 1h20v20H1z"
          />
          <path
            fill="currentColor"
            d="M11.2 5c.3-.3.7-.3.9 0l5.3 5.3c.3.3.3.7 0 .9l-5.3 5.3c-.3.3-.7.3-.9 0l-.6-.6c-.3-.3-.3-.7 0-.9l3.3-3.1H6c-.4 0-.7-.3-.7-.7v-.9c0-.4.3-.7.7-.7h7.9l-3.3-3.1c-.3-.3-.3-.7 0-.9l.6-.6z"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import Logos from '@/components/Logos'

export default {
  filters: {
    dateFormat (value) {
      let dateTime = new Date(value)
      return dateTime.toLocaleDateString('en-GB')
    },
    timeFormat (value) {
      let dateTime = new Date(value)
      return dateTime.toLocaleTimeString('en-GB')
    }
  },
  components: {
    Logos
  },
  data () {
    return {
      pendingSurveys: []
    }
  },
  computed: {
    hasPendingSurveys () {
      return this.pendingSurveys.length > 0
    }
  },
  created () {
    this.$store.dispatch('survey/getPendingSurveys').then(data => {
      this.pendingSurveys = data
    })
  }
}
</script>
